import React, {useState, useLayoutEffect, useEffect} from 'react';
import ReactDOM from 'react-dom';
import ReactMarkdown from 'react-markdown';
import WithThemeProvider from './mobilePartner/WithThemeProvider';
import {
    PromoBox,
    PlanTabsRow,
    PlanTab,
    PlanTabText,
    PlanCardWrapper,
    PlanCard,
    ColumnContent,
    PlanHeader,
    PlanHeaderSelected,
    PlanHeaderImage,
    PlanRibbon,
    PlanRibbonText,
    PlanInnerContainer,
    PlanTitlePrefix,
    PlanTitle,
    PlanPromoText,
    PlanBody,
    PlanBodyText,
    PlanButtonLink,
    PlanButton,
    PlanButtonText,
    PlanPrice,
    PlanPriceSeparator,
    PlanPricePostfix,
    PopupIcon,
    PopupImageHeader,
    PopupBody,
    PopupFooter,
    PlanCurrentLabel,
    PlanCurrentLabelCustom,
    PlanUpcomingLabel,
    NewPlanHeader,
    PlanPromoRibbon,
    PlanPromoRibbonText,
    PlanBodyCtaContainer, columnContent
} from './mobilePartner/GospelPartnerComponents.js';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css/bundle";
import SwiperCore, {
    Pagination
} from 'swiper';
import PlansNameYourOwnPriceModal from './PlansNameYourOwnPriceModal';

// import styled from '@emotion/styled';
// import { css } from "@emotion/react";

// install Swiper modules
SwiperCore.use([Pagination]);

// handle resizing of window
// https://www.pluralsight.com/guides/re-render-react-component-on-window-resize
function debounce(fn, ms) {
    let timer
    return _ => {
        clearTimeout(timer)
        timer = setTimeout(_ => {
        timer = null
        fn.apply(this, arguments)
        }, ms)
    };
}

const PlanCarouselItem = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkoutUrl, setCheckoutUrl] = useState(null);

    const handleSubmit = () => {
        setIsLoading(true);
        return;
    }
    // rules.list_item = (node, children, parent, styles) => (
    //     <PlanBodyBulletItem key={node.key}>
    //         <PlanBodyBulletIcon
    //             name="check"
    //             size={20}
    //         />
    //         {children}
    //     </PlanBodyBulletItem>
    // );
    let item = props.item;
    let headerView;

        headerView = <>
            {/* {item.header_bg_image !== '' && (
                <PlanHeaderImage source={{uri: item.header_bg_image}}
                />
            )} */}
            <PlanHeaderImage source={{uri: `/assets/images/plan_bg-rank-${item.rank}.png`}} />

            {(item.rank == 2 || item.rank == 3) && (<>
            <PlanRibbon backgroundColor={item.rank == '2' ? '#3DE29D' : '#3D4AE2'}>
                <PlanRibbonText color={'#fff'}>{item.rank == '2' ? 'recommended' : 'best value'}</PlanRibbonText>
            </PlanRibbon>
            </>)}

            <PlanInnerContainer isFirst>
                <PlanTitlePrefix>{item.title_prefix}</PlanTitlePrefix>
                <PlanTitle>{item.name}</PlanTitle>
            </PlanInnerContainer>

        </>

    return (
        <PlanCardWrapper className={props.isMobile ? '' : 'col-12 col-md-4'}>
            <PlanCard className={'row no-gutters'} isSelected={item.is_active}>
                <div className={'col'}>


                        <ColumnContent>
                <NewPlanHeader className={'row'} style={{}} isSelected={item.is_active}>
                    {headerView}
                </NewPlanHeader>
                {item.ribbon_text && (
                    <PlanPromoRibbon backgroundColor={item.ribbon_bg_color}>
                        <PlanPromoRibbonText color={item.ribbon_text_color}>{item.ribbon_text}</PlanPromoRibbonText>
                    </PlanPromoRibbon>
                )}

                <PlanBody className={'row'} style={{height: "auto"}} >
                    <PlanBodyText>
                        <ReactMarkdown components={{
                            a({node, href, title, className, children,...props}){
                                return (
                                    <a href="#"
                                        data-toggle="tooltip"
                                        title={title}
                                        className={className}
                                        {...props}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            $('[data-toggle="tooltip"]').tooltip();
                                        } }>
                                            {children}
                                            <i className="fas fa-info-circle"></i>
                                    </a>
                                )
                            }
                        }}>
                            {item.features_text}
                        </ReactMarkdown>
                    </PlanBodyText>
                </PlanBody>

                        </ColumnContent>
                    <div style={{position: 'sticky', bottom: 0}} className={'ml-3 mr-3'}>
                    <PlanBodyCtaContainer className={'row no-gutters'} style={{position: 'static'}}>

                        {(!item.promo_text ?? true) && (
                            <PlanInnerContainer className={'col-12'} style={{marginBottom: '12px'}}>
                                <PlanPromoText>{item.promo_text}</PlanPromoText>
                            </PlanInnerContainer>
                        )}

                        <PlanInnerContainer className={'col-12'}
                            style={typeof giftPlanTierLabels == 'undefined'
                                ? {'flexDirection': 'row', 'alignItems': 'baseline'}
                                : {'flexDirection': 'row', 'alignItems': 'baseline', 'margin-bottom': '20px'}}
                        >
                            {promo && promo.billing_cycle_discount_amount
                                ?
                                    <div className="container-fluid p-0 m-0"> {/* this is for displaying plans with applied promotions (non subscribers) */}
                                        <div className="row no-gutters text-center pb-2">
                                            <div className="col-12" style={{fontSize: '18px', color: '#E37751', textDecorationColor:'#E37751', textDecorationLine: 'line-through'}}>
                                                {item.currencyUnit}{item.price}
                                            </div>
                                        </div>
                                        <div className="row no-gutters">
                                            <div className="col-12">
                                                <div className="card text-center" style={{borderColor: '#FCD36D'}}>
                                                    <div className="card-header p-1 border-0 text-uppercase" style={{background: '#FCD36D'}}>
                                                        {promo.billing_cycle_discount_type == 'dollar' ? item.currencyUnit : ''}
                                                        {promo.billing_cycle_discount_type == 'percent'
                                                            ? Math.floor(promo.billing_cycle_discount_amount)
                                                            : promo.billing_cycle_discount_amount}
                                                        {promo.billing_cycle_discount_type == 'percent' ? '%' : ''} off <span className={'text-lowercase'}>for {promo.number_of_billing_cycles_discount} months</span>
                                                    </div>
                                                    <div className="card-body p-2 d-flex justify-content-center align-items-center">
                                                        <PlanPrice>
                                                            {item.currencyUnit}
                                                            {item.promo_price}
                                                        </PlanPrice>
                                                        <PlanPriceSeparator>
                                                            <PlanPricePostfix
                                                                style={{display: 'inline'}}>{item.price_postfix_text}</PlanPricePostfix>
                                                        </PlanPriceSeparator>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <>{!item.isSubscriptionWithActiveRecurringDiscount
                                        ?
                                        <>{/* this is for displaying current plans with their normal prices */}
                                            <PlanPrice>
                                                {item.currencyUnit}
                                                {item.active_custom_price ? item.active_custom_price : item.price}
                                            </PlanPrice>
                                            <PlanPriceSeparator>
                                                <PlanPricePostfix
                                                    style={{display: 'inline'}}>{item.price_postfix_text}</PlanPricePostfix>
                                            </PlanPriceSeparator>
                                        </>
                                        :
                                        <div className="container-fluid p-0 m-0"> {/* this is for displaying current plans with applied promotions */}
                                            <div className="row no-gutters text-center pb-2">
                                                <div className="col-12" style={{fontSize: '18px', color: '#E37751', textDecorationColor:'#E37751', textDecorationLine: 'line-through'}}>
                                                    {item.currencyUnit}{item.price}
                                                </div>
                                            </div>
                                            <div className="row no-gutters">
                                                <div className="col-12">
                                                    <div className="card text-center" style={{borderColor: '#FCD36D'}}>
                                                        <div className="card-header p-1 border-0 text-uppercase" style={{background: '#FCD36D'}}>
                                                            {item.currentPlanPromoDetails.billing_cycle_discount_type == 'dollar' ? item.currencyUnit : ''}
                                                            {item.currentPlanPromoDetails.billing_cycle_discount_type == 'percent'
                                                                ? Math.floor(item.currentPlanPromoDetails.billing_cycle_discount_amount)
                                                                : item.currentPlanPromoDetails.billing_cycle_discount_amount}
                                                            {item.currentPlanPromoDetails.billing_cycle_discount_type == 'percent' ? '%' : ''} off
                                                        </div>
                                                        <div className="card-body p-2 d-flex justify-content-center align-items-center">
                                                            <PlanPrice>
                                                                {item.currencyUnit}
                                                                {item.currentPlanPromoDetails.promo_price}
                                                            </PlanPrice>
                                                            <PlanPriceSeparator>
                                                                <PlanPricePostfix
                                                                    style={{display: 'inline'}}>{item.price_postfix_text}</PlanPricePostfix>
                                                            </PlanPriceSeparator>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }</>



                            }


                        </PlanInnerContainer>


                        {(typeof giftPlanTierLabels == 'undefined') ?
                            isSubscriber
                                ?
                                item.is_active
                                    ?
                                    <>{item.upcoming_active_date
                                        ?
                                        <PlanUpcomingLabel>New plan starting<br/>from {nextBillingDate}
                                        </PlanUpcomingLabel>
                                        :
                                        <>{item.active_custom_price
                                            ?
                                            <>
                                                <PlanCurrentLabelCustom className="pb-1 pt-1">Your current plan
                                                    (custom)</PlanCurrentLabelCustom>
                                                <PlanButtonLink backgroundColor={item.get_button_bg_color_light}
                                                                id={`get-${item.sku_code}`}
                                                                href={item.allow_any_amount ? '#' : item.url}
                                                                onClick={item.allow_any_amount ? () => {
                                                                    setIsModalOpen(!isModalOpen)
                                                                } : null}
                                                                className="mt-0"
                                                >
                                                    <PlanButtonText color={`#629EBF`}>
                                                        Edit amount
                                                    </PlanButtonText>
                                                </PlanButtonLink>
                                            </>
                                            : <PlanCurrentLabel>Current
                                                plan {item.upcoming_active_date}</PlanCurrentLabel>
                                            }</>
                                        }</>
                                    :
                                        <>
                                            <PlanButton backgroundColor={item.get_button_bg_color_light}
                                                        href="#"
                                                        id={`get-${item.sku_code}`}
                                                        data-toggle="modal"
                                                        data-target={!isSubscriptionWithActiveRecurringDiscount ? '#modal' + item.sku_code : ''}
                                                        disabled={!isSubscriptionWithActiveRecurringDiscount ? '' : "disabled"}
                                            >
                                                <PlanButtonText color={item.get_button_text_color_light}>
                                                    {item.get_button_text || 'Get ' + item.name}
                                                </PlanButtonText>
                                            </PlanButton>
                                        </>

                                : <PlanButton backgroundColor={item.get_button_bg_color_light}
                                              id={`get-${item.sku_code}`}
                                              href={(item.allow_any_amount && (!promo?.billing_cycle_discount_amount ?? true)) ? '#' : item.url}
                                              onClick={(item.allow_any_amount && (!promo?.billing_cycle_discount_amount ?? true))
                                                  ? () => {
                                                      setCheckoutUrl(`${item.url}&amount=`)
                                                      setIsModalOpen(!isModalOpen)
                                                    }
                                                  : null}
                                >
                                    {!item.is_active ?
                                        <PlanButtonText
                                            color={item.get_button_text_color_light}
                                            id={`get-${item.sku_code}`}
                                        >
                                            {'Get ' + item.name}
                                        </PlanButtonText>
                                        : ''}
                                </PlanButton>
                            : ''}


                    </PlanBodyCtaContainer>
                    </div>
            </div>
            </PlanCard>

            <PlansNameYourOwnPriceModal
                planName={item.name}
                activeCustomPrice={item.active_custom_price}
                isOnEditMode={item.active_custom_price ? true : null}
                isModalOpen={isModalOpen}
                suggestedPrices={(item.active_custom_price)
                    ? [
                        {'amount': item.price, 'label': 'Revert to'},
                        {'amount': '100', 'label': null},
                        {'amount': '150', 'label': null},
                    ]
                    : [
                        {'amount': '80', 'label': null},
                        {'amount': '100', 'label': null},
                        {'amount': '150', 'label': null},
                    ]
                }
                defaultPrice={item.price}
                currencyUnit={item.currencyUnit}
                handleModalClose={() => setIsModalOpen(false)}
                checkOutUrl={checkoutUrl}
            />

        </PlanCardWrapper>
    )
}

const ChoosePlan = () => {
    const [activeTab, setActiveTab] = useState(defaultPlanIndex);
    const [swiperRef, setSwiperRef] = useState(null);
    const [customAmount, setCustomAmount] = useState(data[2].price);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [selectedCustomOption, setSelectedCustomOption] = useState(0);

    // handle window resize
    const [dimensions, setDimensions] = useState({ height: window.innerHeight, width: window.innerWidth});

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        }, 300)

        window.addEventListener('resize', debouncedHandleResize)

        return _ => {
          window.removeEventListener('resize', debouncedHandleResize)

        }
    });

    const pressTab = (index) => {
        swiperRef.slideTo(index);
        setActiveTab(index);
        //ga('send', 'event', 'GP Plans', 'Click Plan Tabs', index);
    }

    const changeAmount = (event) => {
        let newAmount = event.target.value;
        if (newAmount >= data[2].price) {
            setCustomAmount(newAmount);
            setShowErrorMessage(false);
        } else {
            setCustomAmount(newAmount);
            setShowErrorMessage(true);
        }
    }

    const increaseAmount = () => {
        setCustomAmount((parseFloat(customAmount) + 10).toFixed(2));
        setShowErrorMessage(false);
    }

    const decreaseAmount = () => {
        let newAmount = parseFloat(customAmount) - 10;
        if(newAmount < data[2].price){
            setCustomAmount(data[2].price)
        } else {
            setCustomAmount(newAmount.toFixed(2));
        }
        setShowErrorMessage(false);
    }

    const handleReset = () => {
        $("#PromoModal").modal('hide');
        setCustomAmount(data[2].price);
        setShowErrorMessage(false);
    }

    const handleSwipe = () => {
        setActiveTab(swiperRef.activeIndex);
        //ga('send', 'event', 'GP Plans', 'Swipe', swiperRef.activeIndex);
    }

    // load tooltips using bootstrap JS
    useLayoutEffect(() => {

        if(data[0].promo_text){
            // $("#PromoModal").modal('show');
        }
    }, []);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    });

    // replace last random backward slash that appears
    // let subscriptionIncludesDataDescription = subscriptionIncludesData.description.replace(/\\+\n/g, "\n");
    let subscriptionIncludesDataDescription = "";
    return (
        <WithThemeProvider colorScheme={colorScheme}>
            <div className="plans__wrapper">
                <div className="container pl-0 pr-0">
                        {promo && promo['code'] === 'freemonth' && (
                        <div className="row">
                            <div className="col-12 mt-4">
                                <h1 class="plans__ribbon">
                                    <strong class="plans__ribbon-content">First month free</strong>
                                </h1>
                            </div>
                        </div>
                        )}
                        {promo && promo.code != 'freemonth' && (
                        <div className="row">
                            <div className="col-12 mt-4 pt-4">
                                <PromoBox>
                                    <div>
                                        <span className="h2--sermon">{promo.name}</span>
                                    </div>
                                    <p className="mb-0 mt-0">{promo.description}
                                    {showGPLink === 1 ?
                                        <span><br/>Visit <a href="https://gospelpartner.com/?utm_source=josephprince.com&utm_medium=referral&utm_campaign=JPComPlansPage" target="_blank">GospelPartner.com</a> to learn more about this new initiative.</span>
                                    :''}
                                    </p>
                                </PromoBox>
                            </div>
                        </div>
                                    )}
                    <div className="row">
                        <div
                            className={typeof giftPlanTierLabels == 'undefined'
                                ? (promo && promo['code']) === 'freemonth'
                                    ? `col-12 text-center pt-2 pb-4 mb-4`
                                    : `col-12 text-center pt-3 pb-4 mb-4 mt-4`
                                : `col-12 text-left pt-3 pb-3 mb-0 mt-5`}>
                            <h1 className="plans__h2">
                                {typeof giftPlanTierLabels == 'undefined'
                                    ? isSubscriber
                                        ? `Choose a plan`
                                        : (isFullContent) ? `Select a plan below & let’s make a real difference together!` : 'Select a plan below'

                                    : 'Browse our Gospel Partner plans'}
                            </h1>
                            {typeof giftPlanTierLabels == 'undefined'
                                ? isSubscriber
                                    ? ''
                                    :
                                    ((promo && promo['code']) === 'freemonth') ? <h5 className="plans__h5">Enjoy your first month’s subscription free for the plan of
                                        your choice!</h5> : ""
                                : ''}
                        </div>
                    </div>

                    <div className="show-mobile-only row">
                        <PlanTabsRow>
                            {data.map((item, index, array) =>
                                <PlanTab
                                    onClick={() => pressTab(index)}
                                    isActive={index === activeTab}
                                    isFirst={index === 0}
                                    isLast={index === array.length-1}
                                    activeOpacity={0.5}
                                    key={index}>
                                    <PlanTabText isActive={index === activeTab}>
                                    {item.name}
                                    </PlanTabText>
                                </PlanTab>
                            )}
                        </PlanTabsRow>
                    </div>

                    <div className="row pl-md-2 pr-md-2">
                        {dimensions.width <= 767 ?
                               <Swiper
                                    initialSlide={defaultPlanIndex}
                                    onSwiper={setSwiperRef}
                                    slidesPerView={'auto'}
                                    centeredSlides={true}
                                    centeredSlidesBounds={true}
                                    spaceBetween={15}
                                    slideToClickedSlide={true}
                                    onSlideChange={() => swiperRef ? handleSwipe() : null}
                                    onAfterInit={() => { $('[data-toggle="tooltip"]').tooltip(); } }
                                    pagination={{"clickable": true }}
                                    className="mySwiper pt-3">

                                    {data.map((item, index) =>
                                        <SwiperSlide key={index}>
                                            <PlanCarouselItem item={item} itemIndex={index} key={index} isMobile isActive={index === activeTab} />
                                        </SwiperSlide>
                                    )}
                                </Swiper>
                        :
                            data.map((item, index) =>
                                <PlanCarouselItem item={item} itemIndex={index} key={index} />
                            )
                        }
                    </div>



                </div>
            </div>

            {/* Pop-up for Promo */}
            {promo && promo['code'] === 'launch2022' && showGoldenTicket === 0 && (
                <div className="modal fade show" id="PromoModal" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header" style={{borderBottom: 'none'}}>
                                <h5 className="modal-title" style={{display: 'none'}}>Here is your gift!</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{zIndex: 1055}}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body pr-4 pl-4" style={{marginTop: '-50px'}}>
                                <PopupIcon/>
                                <div className="text-center mt-3 mb-4">
                                    Redeem your 1 month of free subscription!
                                </div>
                                <div className="row">
                                    <div className="col-12 mb-2 text-center">
                                        <PlanButton fullWidth data-dismiss="modal">
                                            <PlanButtonText>See Subscription Plans</PlanButtonText>
                                        </PlanButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {promo && promo['code'] === 'launch2022' && showGoldenTicket === 1 && (
                <div className="modal fade show" id="PromoModal" tabIndex="-1" role="dialog">
                    <div className="modal-dialog GoldenTicketModal" role="document">
                        <div className="modal-content">
                            <PopupImageHeader className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{color: '#fff', zIndex: 1055}}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </PopupImageHeader>
                            <PopupBody className="modal-body">
                                <h2 className="h2--sermon">A special note from <br className="show-mobile-only" />Pastor Prince to you</h2>
                                <p>
                                    Dear friend,
                                </p>
                                <p>
                                    Thanks for ordering <em>Expedition Promised Land</em>! I deeply appreciate your support and want you to be the first to know about something special we will be launching in January 2022: <strong>monthly subscription plans</strong> on the Joseph Prince app.
                                </p>
                                <p>
                                    Together with your order of <em>Expedition Promised Land</em>, I would like to bless you with <strong>one month of free access</strong> to the subscription plan of your choice. If you opt for the unlimited plan, you will have access to over 1,200 sermons completely free in your first month (feel free to cancel the plan after that).
                                </p>
                                <p>
                                    These subscription plans are part of a new initiative called <strong>Gospel Partner</strong>, where our <em>hazon</em> vision is to reach many more people with the gospel of grace. Your support will help us to make selected messages completely free to thousands around the world every single week and sow into missional projects like the translation and distribution of free resources and books. <strong>So when you sign up for a subscription plan, you are not only getting access to more sermons, but you are also making a difference in helping us get the gospel out in a big way!</strong>
                                </p>
                                <p>
                                    In His grace,<br/>
                                Pastor Prince
                                </p>
                            </PopupBody>
                            <PopupFooter className="modal-footer text-center">
                                <strong className="mb-3">Exclusive Pre-Launch Offer: <br className="hide-mobile-only" />
                                Get one month free access to 5, 10 or 20 years of sermons!</strong>
                                <PlanButton fullWidth backgroundColor={"#E37751"} data-dismiss="modal">
                                    <PlanButtonText>See Subscription Plans</PlanButtonText>
                                </PlanButton>
                            </PopupFooter>
                        </div>
                    </div>
                </div>
            )}
        </WithThemeProvider>
    );
};

ReactDOM.render(<ChoosePlan />, document.getElementById("ChoosePlan"));
